<template>
  <div>
    <h1 class="h3">Connect your accounts</h1>
    <p>Authenticate your social channels. Instagram is required to proceed.</p>
    <ValidationProvider rules="required" name="ig-active">
      <input type="hidden" name="ig-active" v-model="hidden_input_model">
    </ValidationProvider>
    <div class="SocialInfo">
      <iframe
        v-show="embed_code !== ''"
        class="SocialInfo__embed"
        :src="iframe_src"
        frameborder="0"
        title="Social Media Account Connection"
      />
      <div class="SocialInfo__content">
        <p>By connecting your account(s), you are authorizing read-only access to metrics and data related to your social accounts. We will NEVER post content on your behalf, nor will we follow pages, like or comment on posts or content.</p>
        <p>NOTE: You retain the right to revoke authorization for access to your account as needed by clicking the unlink button next to your account.</p>
        <p>For More Information, click here: <a class="font-weight-bold text-underline SocialInfo__link" href="https://support.creatoriq.com/hc/en-us/articles/360001993392-Authenticating-Your-Social" target="_blank"  aria-label="Authenticating Your Social Account (link opens in a new tab.)">Authenticating Your Social Account</a></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SocialInfo',
  data() {
    return {
      embed_code: '',
      is_instagram_enabled: false,
      hidden_input_model: '',
      handle: null,
    };
  },
  watch: {
    is_instagram_enabled(newVal) {
      if (newVal === true) {
        this.hidden_input_model = 'active';
      } else {
        this.hidden_input_model = '';
      }
      this.$nextTick(this.validateStep);
    },
  },
  computed: {
    iframe_src() {
      return this.buildEmbedUrl(this.embed_code);
    },
    current_route() {
      return this.$route.name;
    },
  },
  mounted() {
    this.getEmbedCode();
    this.checkInstgram();
  },
  destroyed() {
    clearInterval(this.handle);
  },
  methods: {
    async getEmbedCode() {
      try {
        const path = 'crewmember';
        const data = this.$store.getters.getCrewMember;
        const results = await this.axios.post(path, data);

        this.embed_code = results.data.linkAccountPage;
        this.$store.dispatch('sessionId', results.data.id);
      } catch (error) {
        console.log(`Error: ${error}`);
      }
    },
    async getInstagram() {
      try {
        const path = 'crewmember/instagram';
        const params = {
          id: this.$store.state.SessionId,
        };
        const results = await this.axios.get(path, { params });
        this.is_instagram_enabled = results.data.connected;
      } catch (error) {
        console.log(`Error: ${error}`);
      }
    },
    checkInstgram() {
      this.handle = setInterval(this.getInstagram, 5000);
    },
    buildEmbedUrl(url) {
      if (!url) {
        return '';
      }

      const [baseUrl, fragment] = url.split('#');
      const hasEmbedParam = /([?&])embed=/.test(baseUrl);
      const separator = baseUrl.includes('?') ? '&' : '?';
      const urlWithEmbed = hasEmbedParam
        ? baseUrl.replace(/([?&])embed=[^&]*/u, '$1embed=1')
        : `${baseUrl}${separator}embed=1`;

      return fragment ? `${urlWithEmbed}#${fragment}` : urlWithEmbed;
    },
    validateStep() {
      this.$emit('onValidate', null);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_breakpoints.scss';

.SocialInfo {
  margin: 0 auto;
  max-width: 570px;
  border-radius: 12px;
  background: white;

  @include media-breakpoint-down(md) {
    margin: 0 15px;
  }

  &__embed {
    height: 595px;
    width: 100%;
    border-radius: 10px;
    padding-top: 25px;
  }

  &__content {
    padding: 20px 40px;

    @include media-breakpoint-down(sm) {
      padding: 20px 15px;
    }

    p {
      color: $gray-alt;
      text-align: center;
      font-size: 12px;
      line-height: 14px;
    }

    a {
      font-size: 12px;
    }
  }
  &__link {
    color: #2d46f4;
  }
}
</style>
